<template>
  <div class="sendWarn">
    <el-input
      v-model="formJson"
      placeholder="请输入预警内容"
      type="textarea"
      :autosize="{ minRows: 15, maxRows: 20 }"
      style="margin-bottom: 20px"
    ></el-input>
    <el-button type="primary" @click="sendWarn">发送预警</el-button>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'SendWarn',
  setup() {
    const { commit, dispatch } = useStore()
    const formJson = ref(
      JSON.stringify({
        queryTime: '2025-08-07 08:00',
        warnList: [
          {
            warnId: 'test1',
            warnType: '暴雨',
            warnStatus: '发布',
            warnLevel: '黄色',
            publishTime: '2025-08-07 08:00',
            publishOrg: '台山市气象台',
            warnAreaCode: '440781',
            warnArea: '台山市',
            warnContent:
              '【台山雷雨黄色预警】预计未来6小时，我市有雷暴、短时强降水和短时大风等强对流天气，台山市气象台8月7日8时发布雷雨大风黄色预警信号，请注意防御。'
          }
        ]
      })
    )
    const sendWarn = () => {
      if (!formJson.value) {
        return
      }
      console.log(73232, formJson.value, JSON.parse(formJson.value))
      dispatch('fetchSendWeatherWarn', JSON.parse(formJson.value)).then(res => {
        commit('setError', {
          status: true,
          title: '预警发送成功',
          message: '预警发送成功...',
          type: 'success'
        })
      })
    }
    return {
      formJson,
      sendWarn
    }
  }
}
</script>
<style scoped>
.sendWarn {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
}
</style>
